/**
 * The rooteed brand mark. Two variants:
 *   - "icon" — the sprout-with-roots circle alone (no wordmark). Use in
 *     the sidebar nav, navbars, avatar slots, anywhere we need a compact
 *     square mark.
 *   - "full" — icon + wordmark stacked. Use on auth screens, About hero,
 *     marketing pages where the brand needs room to breathe.
 *
 * Both pull from `/public/brand/` so they're served by the static host
 * and cached by the service worker as durable assets.
 */
export default function Logo({ variant = "icon", size = 40, className = "", alt = "rooteed" }) {
    if (variant === "full") {
        return (
            <img
                src="/brand/rooteed-logo.png"
                alt={alt}
                width={size}
                height={size}
                style={{ width: size, height: "auto" }}
                className={`block ${className}`}
                draggable={false}
            />
        );
    }
    return (
        <img
            src="/brand/rooteed-icon.png"
            alt={alt}
            width={size}
            height={size}
            style={{ width: size, height: size }}
            className={`block object-contain ${className}`}
            draggable={false}
        />
    );
}
